export default __webpack_public_path__ + "ring-plus-fill.6fc091e261dba098.svg";